import { Injectable } from '@angular/core';
import { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import { TransitTaskPageInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-page.dto';
import { TransitTaskQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-query.dto';
import type { CommentaryFileFindInterface } from '@zaoblako/shared/modules/storage/dtos/commentary-file-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountTransitTaskService extends BaseService {
  protected baseUrl = '/personal-account/cctv/transit-task';

  public findPage(queryParams: TransitTaskQueryInterface): Observable<TransitTaskPageInterface> {
    return this.http.get<TransitTaskPageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getFiles(taskId: number): Observable<CommentaryFileFindInterface[]> {
    return this.http.get<CommentaryFileFindInterface[]>(`${this.baseUrl}/${taskId}/files`);
  }

  public getAvailableRooms(): Observable<RoomFindInterface[]> {
    return this.http.get<RoomFindInterface[]>('/personal-account/cctv/rooms');
  }
}
